import { hubFr, hubEn } from "./hub";
import { landingFr, landingEn } from "./landing";
import { socialFr, socialEn } from "./social";
import { growFr, growEn } from "./grow";

export const LANGUAGES = [
  { code: "fr", label: "Français" },
  { code: "en", label: "English" },
  { code: "es", label: "Español" },
  { code: "pt", label: "Português" },
  { code: "de", label: "Deutsch" },
  { code: "it", label: "Italiano" },
  { code: "nl", label: "Nederlands" },
  { code: "pl", label: "Polski" },
  { code: "tr", label: "Türkçe" },
  { code: "ru", label: "Русский" },
  { code: "ar", label: "العربية", rtl: true },
  { code: "hi", label: "हिन्दी" },
  { code: "ja", label: "日本語" },
  { code: "ko", label: "한국어" },
  { code: "zh", label: "中文" },
];

export const fr = {
  "nav.dashboard": "Tableau de bord",
  "nav.clips": "Mes clips",
  "nav.workspace": "Espace de travail",
  "nav.ai_active": "IA active",
  "nav.ai_text": "Gemini 3 Flash scanne tes vidéos et détecte les moments viraux.",
  "nav.workspace_label": "Workspace",
  "nav.logout": "Déconnexion",
  "nav.language": "Langue",
  "nav.auto_lang": "Auto (selon ta position)",

  "auth.engine": "AI Highlight Engine",
  "auth.hero1": "Tes meilleurs moments.",
  "auth.hero2": "Clippés par l'IA.",
  "auth.hero_sub": "Upload ta game, l'IA trouve les kills, clutchs et fails, recadre pour chaque plateforme et écrit tes titres et hashtags.",
  "auth.perk1_t": "Détection auto des highlights",
  "auth.perk1_d": "Score de viralité pour chaque moment",
  "auth.perk2_t": "Découpe & recadrage précis",
  "auth.perk2_d": "9:16, 16:9, 1:1, 4:5 rendus en vrai MP4",
  "auth.perk3_t": "Prêt pour toutes les plateformes",
  "auth.perk3_d": "TikTok, Shorts, Reels, YouTube, X, Twitch",
  "auth.tab_login": "Connexion",
  "auth.tab_register": "Créer un espace",
  "auth.title_login": "Bon retour, clipper.",
  "auth.title_register": "Lance ton espace.",
  "auth.sub_login": "Connecte-toi avec l'ID de ton espace de travail.",
  "auth.sub_register": "Chaque espace (tenant) isole tes vidéos, clips et membres.",
  "auth.ws_name": "Nom de l'espace",
  "auth.ws_id": "ID Espace de travail",
  "auth.ws_id_opt": "ID Espace (optionnel)",
  "auth.nickname": "Ton pseudo",
  "auth.email": "Email",
  "auth.password": "Mot de passe",
  "auth.submit_login": "Entrer dans CLIP-EX",
  "auth.submit_register": "Créer mon espace",
  "auth.welcome_back": "Bon retour sur CLIP-EX",
  "auth.ws_created": "Espace de travail créé",

  "dash.label": "Tableau de bord",
  "dash.hello": "Prêt à clipper, ",
  "dash.sub": "Dépose une VOD, l'IA détecte les moments forts et te prépare des clips pour chaque plateforme.",
  "dash.videos": "Vidéos",
  "dash.highlights": "Moments IA",
  "dash.clips": "Clips exportés",
  "dash.saved": "Temps gagné",
  "dash.queue": "File de rendu",
  "dash.queue_sub": "clips en cours de rendu FFmpeg",
  "dash.queue_note": "{h}h de gameplay analysées dans cet espace. Les rendus tournent en arrière-plan, tu peux continuer à clipper.",
  "dash.recent": "Projets récents",
  "dash.count": "{n} vidéo(s)",
  "dash.empty": "Aucune vidéo pour l'instant. Upload ta première game au-dessus.",
  "dash.confirm_delete": "Supprimer « {t} » ?",
  "dash.deleted": "Vidéo supprimée",

  "up.drop": "Dépose ta vidéo de gameplay",
  "up.formats": "MP4, MOV, MKV, WEBM — VOD, replay, stream",
  "up.progress": "Upload {p}%",
  "up.game": "Jeu (ex: Valorant, Fortnite, CS2...)",
  "up.focus": "Consigne IA (ex: que les kills au sniper)",
  "up.auto": "Suggérer automatiquement les meilleurs moments avec l'IA",
  "up.bad_format": "Format non supporté. Utilise MP4, MOV, MKV ou WEBM.",
  "up.done_ai": "Vidéo envoyée — l'IA démarre le scan",
  "up.done": "Vidéo envoyée",

  "st.uploading": "Upload...",
  "st.processing": "Traitement",
  "st.analyzing": "Scan IA en cours",
  "st.uploaded": "Prête",
  "st.ready": "Moments détectés",
  "st.error": "Erreur",
  "card.no_game": "Jeu non précisé",
  "card.moments": "{n} moments",
  "card.clips": "{n} clips",

  "ed.loading": "Chargement...",
  "ed.label": "Éditeur IA",
  "ed.unknown_game": "Jeu inconnu",
  "ed.preview": "Prévisualiser la sélection",
  "ed.start_here": "Début ici",
  "ed.end_here": "Fin ici",
  "ed.save_moment": "Sauver ce moment",
  "ed.suggested": "Moments suggérés",
  "ed.moment_added": "Moment ajouté",
  "ed.manual": "Moment manuel",
  "ed.detected": "{n} moments forts détectés par l'IA",
  "ed.no_highlights": "Aucun moment détecté. Lance le scan IA ou ajoute un moment manuel.",

  "cat.kill": "Kill", "cat.clutch": "Clutch", "cat.funny": "Drôle", "cat.fail": "Fail",
  "cat.epic": "Épique", "cat.reaction": "Réaction", "cat.skill": "Skill", "cat.rage": "Rage",

  "an.title": "Détection IA des moments",
  "an.focus": "Consigne : ex. clutchs 1v3, moments drôles, rage...",
  "an.count": "Nb clips",
  "an.min": "Durée min (s)",
  "an.max": "Durée max (s)",
  "an.running": "L'IA analyse la vidéo...",
  "an.rerun": "Relancer la suggestion IA",
  "an.run": "Proposer les meilleurs moments",
  "an.started": "Scan IA lancé — Gemini regarde ta vidéo",

  "ex.title": "Export du clip",
  "ex.platform": "Plateforme",
  "ex.format": "Format",
  "ex.framing": "Cadrage",
  "ex.crop": "Recadrer",
  "ex.blur": "Fond flou",
  "ex.quality": "Qualité",
  "ex.position": "Position du cadre (gauche ↔ droite)",
  "ex.post_text": "Texte de publication",
  "ex.gen_ai": "Générer avec l'IA",
  "ex.clip_title": "Titre du clip",
  "ex.caption": "Caption / description",
  "ex.export": "Exporter le clip",
  "ex.min_score": "Score minimum",
  "ex.auto_all": "Clipper auto tous les moments ({n})",
  "ex.ai_done": "Titre, caption et hashtags générés",
  "ex.started": "Export lancé — rendu en cours",
  "ex.started_sub": "Retrouve-le dans « Mes clips »",
  "ex.auto_started": "{n} clips IA en cours de rendu",

  "cl.label": "Export Hub",
  "cl.title1": "Mes ",
  "cl.title2": "clips",
  "cl.sub": "Tous tes clips rendus, prêts à poster. Télécharge, copie le texte IA et publie.",
  "cl.all": "Tous",
  "cl.empty": "Aucun clip ici. Ouvre une vidéo et exporte ton premier clip.",
  "cl.rendering": "Rendu FFmpeg...",
  "cl.failed": "Échec du rendu",
  "cl.download": "Télécharger",
  "cl.retry": "Relancer",
  "cl.copy": "Copier le texte",
  "cl.publish": "Publier",
  "cl.delete": "Supprimer",
  "cl.select": "Sélectionner ce clip",
  "cl.select_all": "Tout sélectionner",
  "cl.selected": "{n} sélectionné(s)",
  "cl.clear_sel": "Désélectionner",
  "cl.bulk_delete": "Supprimer ({n})",
  "cl.bulk_confirm": "Supprimer définitivement {n} clip(s) ? Cette action est irréversible.",
  "cl.bulk_done": "{n} clip(s) supprimé(s)",
  "cl.edit": "Éditer",
  "cl.edit_hint": "Rééditer ce clip — l'original reste intact",
  "ed.reedit_loaded": "Clip chargé dans l'éditeur — l'export créera une nouvelle version",
  "cl.copied": "Titre + caption + hashtags copiés",
  "cl.publish_done": "Texte copié — colle-le sur la plateforme",
  "cl.confirm_delete": "Supprimer ce clip ?",
  "cl.deleted": "Clip supprimé",
  "cl.rerendered": "Rendu relancé",

  "ws.tenant": "Tenant",
  "ws.title1": "Espace de ",
  "ws.title2": "travail",
  "ws.name": "Nom",
  "ws.id_hint": "ID Espace (à utiliser pour se connecter)",
  "ws.role": "Ton rôle",
  "ws.add": "Ajouter un membre (monteur, clipper...)",
  "ws.nickname": "Pseudo",
  "ws.member": "Membre",
  "ws.admin": "Admin",
  "ws.add_btn": "Ajouter",
  "ws.added": "Membre ajouté",
  "ws.copied": "ID copié",
  "auth.demo": "Essayer le compte démo",
  "auth.demo_hint": "Accès public instantané, sans inscription",
  "auth.try_cta": "Pas encore de compte ? Essaie gratuitement",
  "auth.try_perk": "🎁 3 clips gratuits chaque semaine, sans carte de crédit. Ton premier clip en moins de 2 minutes !",
  "auth.try_hint": "Inscription en 30 secondes · aucune carte requise",
  "auth.or": "ou",
  "dash.tips": "Astuces IA",
  "dash.tip1": "Donne une consigne précise (ex : « que les clutchs ») pour des suggestions ciblées.",
  "dash.tip2": "Le format 9:16 avec fond flou garde toute l'action visible sur TikTok et Shorts.",
  "dash.tip3": "« Clipper auto » rend tous les moments d'un coup : publie une série en 1 clic.",
  "ws.demo_note": "Compte démo public : l'ajout de membres est désactivé.",
  "ws.members": "Membres",
  "nav.integrations": "Connexions",
  "load.loading": "Chargement de CLIP-EX",
  "fx.title": "Effets de malade",
  "fx.ai": "Effets IA",
  "fx.hook": "Texte choc (incrusté 3s au début)",
  "fx.zoom": "Zoom lent", "fx.shake": "Shake", "fx.flash": "Flash", "fx.neon": "Néon",
  "fx.vignette": "Vignette", "fx.chroma": "Glitch RGB", "fx.slowmo": "Ralenti x0.5", "fx.fadeout": "Fondu fin",
  "fx.watermark": "Logo CLIP-EX", "fx.hook_fx": "Texte choc", "fx.neon_frame": "Cadre néon",
  "fx.applied": "Effets suggérés par l'IA appliqués",
  "up.or_link": "ou importe un lien (Twitch, YouTube, Kick, TikTok...)",
  "up.import": "Importer",
  "up.import_started": "Import lancé — téléchargement puis scan IA",
  "int.label": "Synchronisation",
  "int.title1": "Connecte tes ",
  "int.title2": "plateformes",
  "int.sub": "Clippe directement depuis OBS Studio, TikTok LIVE Studio ou Streamlabs, ou importe un lien. L'IA fait le reste.",
  "int.key": "Clé API de l'espace",
  "int.rotate": "Régénérer",
  "int.rotated": "Nouvelle clé générée — remets à jour tes plugins",
  "int.obs_t": "Plugin OBS Studio",
  "int.obs_d": "Chaque fois que tu sauvegardes un replay (Replay Buffer), le clip est envoyé à CLIP-EX et l'IA le monte.",
  "int.obs_s1": "Télécharge le script ci-dessous (ta clé est déjà dedans).",
  "int.obs_s2": "OBS > Outils > Scripts > + et choisis clipx_obs.py.",
  "int.obs_s3": "Active le Replay Buffer et assigne une touche « Sauvegarder le replay ».",
  "int.obs_dl": "Télécharger le plugin OBS",
  "int.overlay_t": "Overlay live (Browser Source)",
  "int.overlay_d": "Source Navigateur (OBS, Streamlabs) ou « Lien » (TikTok LIVE Studio). 100 % transparente : rien n'apparaît sur ton stream.",
  "int.copy": "Copier",
  "int.open": "Aperçu",
  "int.copied": "Lien copié",
  "int.tiktok_t": "TikTok LIVE Studio",
  "int.tiktok_d": "Ajoute l'overlay comme source « Lien ». Enregistre ton live, puis glisse le fichier ou importe le replay ici pour le clipper.",
  "int.import_t": "Importer un lien",
  "int.import_d": "VOD Twitch, clip Kick, vidéo YouTube ou TikTok : colle le lien, CLIP-EX télécharge et l'IA trouve les meilleurs moments.",
  "int.demo": "Les connexions sont désactivées sur le compte démo public. Crée ton espace gratuit pour les utiliser.",
  "ov.live": "CLIP-EX LIVE",
  "ov.scan": "Scan IA en cours",
  "ov.new": "Moment détecté",
  "ov.clip": "Clip prêt",
  "ov.waiting": "En attente de moments forts...",
  "ck.title": "Ta vie privée, tes choix",
  "ck.text": "CLIP-EX utilise des témoins (cookies) nécessaires au fonctionnement et, avec ton consentement, des témoins de préférences et de mesure d'audience. Conforme à la Loi 25 (Québec).",
  "ck.accept": "Tout accepter",
  "ck.refuse": "Tout refuser",
  "ck.custom": "Personnaliser",
  "ck.save": "Enregistrer mes choix",
  "ck.necessary": "Nécessaires (connexion, sécurité) — toujours actifs",
  "ck.preferences": "Préférences (langue, détection par adresse IP)",
  "ck.analytics": "Mesure d'audience (statistiques anonymisées)",
  "ck.policy": "Politique de confidentialité",
  "ft.rights": "Tous droits réservés.",
  "ft.privacy": "Confidentialité",
  "ft.terms": "Conditions d'utilisation",
  "ft.cookies": "Gérer les témoins",
  "ft.law25": "Conforme Loi 25 · Québec",
  "pv.title": "Mes données (Loi 25)",
  "pv.export": "Exporter mes données",
  "pv.delete": "Supprimer mon compte",
  "pv.confirm": "Supprimer définitivement ton compte et tes vidéos ? Cette action est irréversible.",
  "pv.deleted": "Compte supprimé",
  "int.restricted": "Les plugins et la clé API sont gérés par le propriétaire ou un admin de l'espace. Demande-leur le plugin.",
  "fx.punch": "Zoom punch impact", "fx.quake": "Séisme impact", "fx.bloom": "Bloom lumineux", "fx.cinema": "Bandes cinéma", "fx.bw_hit": "N&B à l'impact",
  "st.title": "Stickers & sons au moment",
  "st.impact": "Impact ici",
  "st.sfx": "Effets sonores (clic sur l'icône pour écouter)",
  "st.pos_center": "Centre", "st.pos_top": "Haut", "st.pos_bottom": "Bas", "st.pos_left": "Gauche", "st.pos_right": "Droite",
  "sfx.boom": "Vine Boom", "sfx.airhorn": "Air horn", "sfx.hitmarker": "Hitmarker", "sfx.whoosh": "Whoosh", "sfx.riser": "Riser",
  "sfx.drop": "Bass drop", "sfx.glitch": "Glitch", "sfx.ding": "Ding", "sfx.bruh": "Bruh", "sfx.laser": "Laser",
  "wm.label": "Logo CLIP-EX dans le coin",
  "wm.soon": "Le filigrane CLIP-EX aide à faire connaître l'app",
  "con.title": "Connecter une plateforme",
  "con.sub": "Clique sur ta plateforme : copie l'overlay ou colle le lien de ton live pour que CLIP-EX le clippe automatiquement.",
  "con.desc": "Branche CLIP-EX sur ta plateforme en 2 étapes.",
  "con.overlay": "Overlay en direct",
  "con.overlay_how": "Optionnel : overlay invisible (source Navigateur / Lien, 1920x1080). Pour « Clipper maintenant », ouvre le panneau privé sur ton téléphone ou en dock.",
  "con.live": "Auto-clip de ton live",
  "con.live_how": "CLIP-EX enregistre ton live par segments, l'IA détecte les meilleurs moments et crée les clips avec effets, stickers et sons.",
  "con.start": "Lancer l'auto-clip du live",
  "live.qty": "Combien de clips l'auto-clip doit prendre ?",
  "live.qty_hint": "L'auto-clip arrête une fois la limite atteinte. Le bouton CLIP et !clip continuent de marcher.",
  "live.auto_count": "Auto-clip : {a} / {m}",
  "live.limit_hit": "Limite atteinte · reclipper encore :",
  "live.more_ok": "+{n} clips ajoutés, l'auto-clip reprend",
  "con.tag_live": "Live auto-clip + overlay",
  "con.tag_overlay": "Overlay + plugin",
  "live.title": "Lives en auto-clip",
  "live.started": "Auto-clip du live lancé — les clips arrivent dans « Mes clips »",
  "live.stopped": "Auto-clip arrêté",
  "live.stop": "Arrêter",
  "live.clip_btn": "CLIP !",
  "live.chat_on": "!clip actif dans le chat",
  "setup.title": "Brancher CLIP-EX à ton live en 5 étapes",
  "setup.desc": "Suis les étapes : chaque voyant devient vert tout seul quand ça fonctionne.",
  "setup.all_ok": "Tout est branché et fonctionne. Bon live !",
  "setup.copied": "Lien copié",
  "setup.live_t": "Lance l'auto-clip de ton live",
  "setup.live_h": "Plus bas, choisis ta plateforme (Twitch, Kick, TikTok…) et colle le lien de ta chaîne pendant que tu es en live.",
  "setup.ov_t": "Ajoute l'alerte dans OBS",
  "setup.ov_h": "OBS → Sources → + → Navigateur → colle ce lien, 1920×1080. Vert dès que OBS l'affiche.",
  "setup.dock_t": "Ajoute le bouton CLIP dans OBS",
  "setup.dock_h": "OBS → Docks → Docks de navigateur personnalisés → Nom : CLIP-EX, URL : ce lien → Appliquer. Clique CLIP sans quitter OBS.",
  "setup.chat_t": "Commande !clip dans le chat",
  "setup.chat_h": "Automatique avec Twitch/Kick : tes modos et VIP tapent !clip ou !clip 60.",
  "setup.chat_na": "Disponible quand ton live est sur Twitch ou Kick.",
  "setup.push_t": "Notifications sur ton cell",
  "setup.push_h": "Mes clips → active « Notification Clip prêt » sur ton cell (iPhone : ajoute CLIP-EX à l'écran d'accueil d'abord).",
  "int.ov_mod": "Alerte néon « CLIP ! par @modo » avec son de ciseaux quand un modo tape !clip (source navigateur 1920×1080 dans OBS; coche « Contrôler l'audio via OBS » pour régler le volume, ou ajoute &vol=50 ou &sound=0 au lien) :",
  "int.ov_mod_preview": "Voir un aperçu de l'alerte",
  "live.bestof": "Voir le best-of du live",
  "live.bestof_wip": "Best-of du live en montage…",
  "live.bestof_hint": "À la fin du live, CLIP-EX monte tout seul un best-of de tes meilleurs clips et te l'envoie sur ton cell.",
  "mods.title": "Classement des modos du mois",
  "mods.desc": "Les modos qui ont fait !clip, classés par vues CLIP-EX de leurs clips ce mois-ci. Leurs clips reçoivent automatiquement un lien de partage. Toi seul le vois.",
  "mods.empty": "Aucun clip fait par un modo ce mois-ci. Dis à tes modos de taper !clip pendant ton live !",
  "mods.clips": "{n} clip(s)",
  "mods.views": "{n} vues",
  "ce.no_live": "Aucun auto-clip de live en cours. Lance-le d'abord depuis Intégrations (lien de ton live).",
  "ce.reconnecting": "Reconnexion au live en cours : réessaie dans quelques secondes.",
  "ce.starting": "Le live vient de démarrer : réessaie dans quelques secondes.",
  "ce.busy": "Un clip est déjà en cours : attends quelques secondes avant le suivant.",
  "ce.credits": "Tes 3 clips gratuits de la semaine sont utilisés. Achète des crédits pour continuer.",
  "ce.bad_key": "Lien du bouton CLIP invalide.",
  "live.chat_hint": "Tes modérateurs et VIP peuvent taper !clip (30 s) ou !clip 60 (15 à 60 s) dans le chat Twitch/Kick (1 clip max toutes les 30 s).",
  "live.chat_last": "dernier par {u}",
  "push.title": "Notification « Clip prêt » sur ce cell / PC",
  "push.desc": "Reçois une notification dès qu'un clip est prêt (IA ou bouton CLIP), même si le site est fermé. À activer sur chaque appareil.",
  "push.ios": "Sur iPhone : touche Partager puis « Sur l'écran d'accueil », ouvre CLIP-EX depuis l'icône, puis active ici.",
  "push.unsupported": "Ce navigateur ne gère pas les notifications.",
  "push.denied": "Notifications refusées : autorise-les dans les réglages du navigateur.",
  "push.on": "Notifications activées sur cet appareil",
  "push.failed": "Impossible d'activer les notifications ici (navigation privée ?). Réessaie dans une fenêtre normale.",
  "push.off": "Notifications désactivées sur cet appareil",
  "qa.title": "Accès rapide au bouton CLIP",
  "qa.desc": "Scanne le code QR avec ton cell ou garde ce lien en favori : il ouvre directement le bouton CLIP, sans connexion. Garde-le secret (tu peux le régénérer dans Intégrations).",
  "qa.copy": "Copier",
  "qa.copied": "Lien du bouton CLIP copié",
  "qa.key": "Sur PC : appuie sur la touche C pendant un live (sur la page du bouton CLIP ou ici) pour clipper.",
  "live.clip_busy": "Clip en cours…",
  "live.clip_ok": "Les 30 dernières secondes sont envoyées : ton clip arrive dans Mes clips.",
  "live.reconnecting": "Reconnexion automatique au live…",
  "live.stats": "{s} segments · {c} clips",
  "live.st_live": "En direct", "live.st_stopped": "Arrêté", "live.st_finished": "Terminé", "live.st_error": "Erreur",
  "ai.title": "Monteur IA — dis-lui quoi faire",
  "ai.sub": "Écris ta demande en une phrase : l'IA place les effets, stickers, sons, texte et recadrage pour toi. Tout reste modifiable.",
  "ai.ph": "ex : rends-le drôle avec un bruh quand il meurt",
  "ai.idea1": "Rends ce clip complètement fou avec des sons et stickers",
  "ai.idea2": "Version drôle style meme avec ralenti au fail",
  "ai.idea3": "Version épique cinéma pour un headshot",
  "ai.applied": "Montage IA appliqué — ajuste ce que tu veux",
  "fx.preview": "Aperçu réel des effets (rendu 6s)",
  "fx.preview_title": "Aperçu du rendu final",
  "fx.preview_loading": "Rendu de l'aperçu...",
  "int.plugins": "Plugins par plateforme",
  "int.dl_watcher": "Télécharger CLIP-EX Watcher",
  "int.watcher_t": "CLIP-EX Watcher (universel)",
  "int.watcher_d": "Surveille ton dossier de captures et envoie chaque nouvelle vidéo à l'IA. Lance : python clipx_watcher.py \"dossier\".",
  "int.bookmarklet_t": "Bouton « Clipper avec CLIP-EX »",
  "int.bookmarklet_d": "Glisse ce bouton dans ta barre de favoris. Sur une page Twitch, Kick, YouTube ou TikTok, clique-le : la vidéo est importée et l'IA trouve les moments.",
  "int.bookmarklet_btn": "Clipper avec CLIP-EX",
  "int.how_overlay": "Overlay (source Navigateur / Lien)",
  "int.how_watcher": "Dossier surveillé (Watcher)",
  "int.how_import": "Import par lien / favori",
  "int.how_script": "Script officiel",
  "int.folder": "Dossier :",
  ...hubFr,
  ...landingFr,
  ...socialFr,
  ...growFr,
};

export const en = {
  "nav.dashboard": "Dashboard",
  "nav.clips": "My clips",
  "nav.workspace": "Workspace",
  "nav.ai_active": "AI active",
  "nav.ai_text": "Gemini 3 Flash scans your videos and detects viral moments.",
  "nav.workspace_label": "Workspace",
  "nav.logout": "Log out",
  "nav.language": "Language",
  "nav.auto_lang": "Auto (based on your location)",

  "auth.engine": "AI Highlight Engine",
  "auth.hero1": "Your best moments.",
  "auth.hero2": "Clipped by AI.",
  "auth.hero_sub": "Upload your game, the AI finds kills, clutches and fails, reframes for every platform and writes your titles and hashtags.",
  "auth.perk1_t": "Automatic highlight detection",
  "auth.perk1_d": "Virality score for every moment",
  "auth.perk2_t": "Precise trimming & reframing",
  "auth.perk2_d": "9:16, 16:9, 1:1, 4:5 rendered as real MP4",
  "auth.perk3_t": "Ready for every platform",
  "auth.perk3_d": "TikTok, Shorts, Reels, YouTube, X, Twitch",
  "auth.tab_login": "Log in",
  "auth.tab_register": "Create a workspace",
  "auth.title_login": "Welcome back, clipper.",
  "auth.title_register": "Launch your workspace.",
  "auth.sub_login": "Log in with your workspace ID.",
  "auth.sub_register": "Each workspace (tenant) isolates your videos, clips and members.",
  "auth.ws_name": "Workspace name",
  "auth.ws_id": "Workspace ID",
  "auth.ws_id_opt": "Workspace ID (optional)",
  "auth.nickname": "Your nickname",
  "auth.email": "Email",
  "auth.password": "Password",
  "auth.submit_login": "Enter CLIP-EX",
  "auth.submit_register": "Create my workspace",
  "auth.welcome_back": "Welcome back to CLIP-EX",
  "auth.ws_created": "Workspace created",

  "dash.label": "Dashboard",
  "dash.hello": "Ready to clip, ",
  "dash.sub": "Drop a VOD, the AI detects the highlights and prepares clips for every platform.",
  "dash.videos": "Videos",
  "dash.highlights": "AI moments",
  "dash.clips": "Exported clips",
  "dash.saved": "Time saved",
  "dash.queue": "Render queue",
  "dash.queue_sub": "clips rendering with FFmpeg",
  "dash.queue_note": "{h}h of gameplay analyzed in this workspace. Renders run in the background, keep clipping.",
  "dash.recent": "Recent projects",
  "dash.count": "{n} video(s)",
  "dash.empty": "No videos yet. Upload your first game above.",
  "dash.confirm_delete": "Delete \"{t}\"?",
  "dash.deleted": "Video deleted",

  "up.drop": "Drop your gameplay video",
  "up.formats": "MP4, MOV, MKV, WEBM — VOD, replay, stream",
  "up.progress": "Uploading {p}%",
  "up.game": "Game (e.g. Valorant, Fortnite, CS2...)",
  "up.focus": "AI instruction (e.g. only sniper kills)",
  "up.auto": "Automatically suggest the best moments with AI",
  "up.bad_format": "Unsupported format. Use MP4, MOV, MKV or WEBM.",
  "up.done_ai": "Video uploaded — AI scan starting",
  "up.done": "Video uploaded",

  "st.uploading": "Uploading...",
  "st.processing": "Processing",
  "st.analyzing": "AI scan running",
  "st.uploaded": "Ready",
  "st.ready": "Moments detected",
  "st.error": "Error",
  "card.no_game": "Game not specified",
  "card.moments": "{n} moments",
  "card.clips": "{n} clips",

  "ed.loading": "Loading...",
  "ed.label": "AI Editor",
  "ed.unknown_game": "Unknown game",
  "ed.preview": "Preview selection",
  "ed.start_here": "Start here",
  "ed.end_here": "End here",
  "ed.save_moment": "Save this moment",
  "ed.suggested": "Suggested moments",
  "ed.moment_added": "Moment added",
  "ed.manual": "Manual moment",
  "ed.detected": "{n} highlights detected by AI",
  "ed.no_highlights": "No moments detected. Run the AI scan or add a manual moment.",

  "cat.kill": "Kill", "cat.clutch": "Clutch", "cat.funny": "Funny", "cat.fail": "Fail",
  "cat.epic": "Epic", "cat.reaction": "Reaction", "cat.skill": "Skill", "cat.rage": "Rage",

  "an.title": "AI moment detection",
  "an.focus": "Instruction: e.g. 1v3 clutches, funny moments, rage...",
  "an.count": "Clips",
  "an.min": "Min length (s)",
  "an.max": "Max length (s)",
  "an.running": "AI is analyzing the video...",
  "an.rerun": "Re-run AI suggestions",
  "an.run": "Suggest the best moments",
  "an.started": "AI scan started — Gemini is watching your video",

  "ex.title": "Clip export",
  "ex.platform": "Platform",
  "ex.format": "Format",
  "ex.framing": "Framing",
  "ex.crop": "Crop",
  "ex.blur": "Blur fill",
  "ex.quality": "Quality",
  "ex.position": "Frame position (left ↔ right)",
  "ex.post_text": "Post text",
  "ex.gen_ai": "Generate with AI",
  "ex.clip_title": "Clip title",
  "ex.caption": "Caption / description",
  "ex.export": "Export clip",
  "ex.min_score": "Minimum score",
  "ex.auto_all": "Auto-clip all moments ({n})",
  "ex.ai_done": "Title, caption and hashtags generated",
  "ex.started": "Export started — rendering",
  "ex.started_sub": "Find it in \"My clips\"",
  "ex.auto_started": "{n} AI clips rendering",

  "cl.label": "Export Hub",
  "cl.title1": "My ",
  "cl.title2": "clips",
  "cl.sub": "All your rendered clips, ready to post. Download, copy the AI text and publish.",
  "cl.all": "All",
  "cl.empty": "No clips here. Open a video and export your first clip.",
  "cl.rendering": "FFmpeg rendering...",
  "cl.failed": "Render failed",
  "cl.download": "Download",
  "cl.retry": "Retry",
  "cl.copy": "Copy text",
  "cl.publish": "Publish",
  "cl.delete": "Delete",
  "cl.select": "Select this clip",
  "cl.select_all": "Select all",
  "cl.selected": "{n} selected",
  "cl.clear_sel": "Clear",
  "cl.bulk_delete": "Delete ({n})",
  "cl.bulk_confirm": "Permanently delete {n} clip(s)? This can't be undone.",
  "cl.bulk_done": "{n} clip(s) deleted",
  "cl.edit": "Edit",
  "cl.edit_hint": "Re-edit this clip — the original stays intact",
  "ed.reedit_loaded": "Clip loaded in the editor — exporting will create a new version",
  "cl.copied": "Title + caption + hashtags copied",
  "cl.publish_done": "Text copied — paste it on the platform",
  "cl.confirm_delete": "Delete this clip?",
  "cl.deleted": "Clip deleted",
  "cl.rerendered": "Render restarted",

  "ws.tenant": "Tenant",
  "ws.title1": "Work",
  "ws.title2": "space",
  "ws.name": "Name",
  "ws.id_hint": "Workspace ID (used to log in)",
  "ws.role": "Your role",
  "ws.add": "Add a member (editor, clipper...)",
  "ws.nickname": "Nickname",
  "ws.member": "Member",
  "ws.admin": "Admin",
  "ws.add_btn": "Add",
  "ws.added": "Member added",
  "ws.copied": "ID copied",
  "auth.demo": "Try the demo account",
  "auth.demo_hint": "Instant public access, no sign-up",
  "auth.try_cta": "No account yet? Try it free",
  "auth.try_perk": "🎁 3 free clips every week, no credit card. Your first clip in under 2 minutes!",
  "auth.try_hint": "Sign up in 30 seconds · no card required",
  "auth.or": "or",
  "dash.tips": "AI tips",
  "dash.tip1": "Give a precise instruction (e.g. \"only clutches\") for targeted suggestions.",
  "dash.tip2": "9:16 with blur fill keeps all the action visible on TikTok and Shorts.",
  "dash.tip3": "\"Auto-clip\" renders every moment at once: publish a series in 1 click.",
  "ws.demo_note": "Public demo account: adding members is disabled.",
  "ws.members": "Members",
  "nav.integrations": "Connections",
  "load.loading": "Loading CLIP-EX",
  "fx.title": "Insane effects",
  "fx.ai": "AI effects",
  "fx.hook": "Hook text (burned in for the first 3s)",
  "fx.zoom": "Slow zoom", "fx.shake": "Shake", "fx.flash": "Flash", "fx.neon": "Neon",
  "fx.vignette": "Vignette", "fx.chroma": "RGB glitch", "fx.slowmo": "Slow-mo x0.5", "fx.fadeout": "Fade out",
  "fx.watermark": "CLIP-EX logo", "fx.hook_fx": "Hook text", "fx.neon_frame": "Neon frame",
  "fx.applied": "AI-suggested effects applied",
  "up.or_link": "or import a link (Twitch, YouTube, Kick, TikTok...)",
  "up.import": "Import",
  "up.import_started": "Import started — downloading then AI scan",
  "int.label": "Sync",
  "int.title1": "Connect your ",
  "int.title2": "platforms",
  "int.sub": "Clip straight from OBS Studio, TikTok LIVE Studio or Streamlabs, or import a link. The AI does the rest.",
  "int.key": "Workspace API key",
  "int.rotate": "Regenerate",
  "int.rotated": "New key generated — update your plugins",
  "int.obs_t": "OBS Studio plugin",
  "int.obs_d": "Every time you save a replay (Replay Buffer), the clip is sent to CLIP-EX and the AI edits it.",
  "int.obs_s1": "Download the script below (your key is already inside).",
  "int.obs_s2": "OBS > Tools > Scripts > + and pick clipx_obs.py.",
  "int.obs_s3": "Enable the Replay Buffer and bind a \"Save replay\" hotkey.",
  "int.obs_dl": "Download the OBS plugin",
  "int.overlay_t": "Live overlay (Browser Source)",
  "int.overlay_d": "Browser source (OBS, Streamlabs) or \"Link\" (TikTok LIVE Studio). 100% transparent: nothing appears on your stream.",
  "int.copy": "Copy",
  "int.open": "Preview",
  "int.copied": "Link copied",
  "int.tiktok_t": "TikTok LIVE Studio",
  "int.tiktok_d": "Add the overlay as a \"Link\" source. Record your live, then drop the file or import the replay here to clip it.",
  "int.import_t": "Import a link",
  "int.import_d": "Twitch VOD, Kick clip, YouTube or TikTok video: paste the link, CLIP-EX downloads it and the AI finds the best moments.",
  "int.demo": "Connections are disabled on the public demo account. Create your free workspace to use them.",
  "ov.live": "CLIP-EX LIVE",
  "ov.scan": "AI scan running",
  "ov.new": "Moment detected",
  "ov.clip": "Clip ready",
  "ov.waiting": "Waiting for highlights...",
  "ck.title": "Your privacy, your choices",
  "ck.text": "CLIP-EX uses cookies required for the service and, with your consent, preference and audience-measurement cookies. Compliant with Quebec's Law 25.",
  "ck.accept": "Accept all",
  "ck.refuse": "Refuse all",
  "ck.custom": "Customize",
  "ck.save": "Save my choices",
  "ck.necessary": "Necessary (login, security) — always on",
  "ck.preferences": "Preferences (language, IP-based detection)",
  "ck.analytics": "Audience measurement (anonymized stats)",
  "ck.policy": "Privacy policy",
  "ft.rights": "All rights reserved.",
  "ft.privacy": "Privacy",
  "ft.terms": "Terms of use",
  "ft.cookies": "Manage cookies",
  "ft.law25": "Law 25 compliant · Quebec",
  "pv.title": "My data (Law 25)",
  "pv.export": "Export my data",
  "pv.delete": "Delete my account",
  "pv.confirm": "Permanently delete your account and videos? This cannot be undone.",
  "pv.deleted": "Account deleted",
  "int.restricted": "Plugins and the API key are managed by the workspace owner or an admin. Ask them for the plugin.",
  "fx.punch": "Impact zoom punch", "fx.quake": "Impact quake", "fx.bloom": "Glow bloom", "fx.cinema": "Cinema bars", "fx.bw_hit": "B&W on impact",
  "st.title": "Stickers & sounds at the moment",
  "st.impact": "Impact here",
  "st.sfx": "Sound effects (click the icon to listen)",
  "st.pos_center": "Center", "st.pos_top": "Top", "st.pos_bottom": "Bottom", "st.pos_left": "Left", "st.pos_right": "Right",
  "sfx.boom": "Vine Boom", "sfx.airhorn": "Air horn", "sfx.hitmarker": "Hitmarker", "sfx.whoosh": "Whoosh", "sfx.riser": "Riser",
  "sfx.drop": "Bass drop", "sfx.glitch": "Glitch", "sfx.ding": "Ding", "sfx.bruh": "Bruh", "sfx.laser": "Laser",
  "wm.label": "CLIP-EX logo in the corner",
  "wm.soon": "The CLIP-EX watermark helps spread the word",
  "con.title": "Connect a platform",
  "con.sub": "Click your platform: copy the overlay or paste your live link so CLIP-EX clips it automatically.",
  "con.desc": "Plug CLIP-EX into your platform in 2 steps.",
  "con.overlay": "Live overlay",
  "con.overlay_how": "Optional: invisible overlay (Browser / Link source, 1920x1080). For \"Clip now\", open the private panel on your phone or as a dock.",
  "con.live": "Auto-clip your live",
  "con.live_how": "CLIP-EX records your live in segments, the AI detects the best moments and creates clips with effects, stickers and sounds.",
  "con.start": "Start live auto-clip",
  "live.qty": "How many clips should auto-clip grab?",
  "live.qty_hint": "Auto-clip stops once the limit is reached. The CLIP button and !clip keep working.",
  "live.auto_count": "Auto-clip: {a} / {m}",
  "live.limit_hit": "Limit reached · clip more:",
  "live.more_ok": "+{n} clips added, auto-clip resumes",
  "con.tag_live": "Live auto-clip + overlay",
  "con.tag_overlay": "Overlay + plugin",
  "live.title": "Lives being auto-clipped",
  "live.started": "Live auto-clip started — clips will land in \"My clips\"",
  "live.stopped": "Auto-clip stopped",
  "live.stop": "Stop",
  "live.clip_btn": "CLIP!",
  "live.chat_on": "!clip on in chat",
  "setup.title": "Plug CLIP-EX into your live in 5 steps",
  "setup.desc": "Follow the steps: each light turns green by itself once it works.",
  "setup.all_ok": "Everything is plugged in and working. Have a great stream!",
  "setup.copied": "Link copied",
  "setup.live_t": "Start the live auto-clip",
  "setup.live_h": "Below, pick your platform (Twitch, Kick, TikTok…) and paste your channel link while you're live.",
  "setup.ov_t": "Add the alert in OBS",
  "setup.ov_h": "OBS → Sources → + → Browser → paste this link, 1920×1080. Turns green as soon as OBS shows it.",
  "setup.dock_t": "Add the CLIP button in OBS",
  "setup.dock_h": "OBS → Docks → Custom Browser Docks → Name: CLIP-EX, URL: this link → Apply. Click CLIP without leaving OBS.",
  "setup.chat_t": "!clip command in chat",
  "setup.chat_h": "Automatic on Twitch/Kick: your mods and VIPs type !clip or !clip 60.",
  "setup.chat_na": "Available when your live is on Twitch or Kick.",
  "setup.push_t": "Notifications on your phone",
  "setup.push_h": "My clips → turn on \"Clip ready notification\" on your phone (iPhone: add CLIP-EX to the home screen first).",
  "int.ov_mod": "Neon \"CLIP! by @mod\" alert with a scissors sound when a mod types !clip (1920×1080 browser source in OBS; tick \"Control audio via OBS\" to set the volume, or add &vol=50 or &sound=0 to the link):",
  "int.ov_mod_preview": "Preview the alert",
  "live.bestof": "Watch the live best-of",
  "live.bestof_wip": "Live best-of being edited…",
  "live.bestof_hint": "When your live ends, CLIP-EX automatically edits a best-of of your top clips and sends it to your phone.",
  "mods.title": "Top mods of the month",
  "mods.desc": "Mods who used !clip, ranked by CLIP-EX views on their clips this month. Their clips get a share link automatically. Only you can see this.",
  "mods.empty": "No mod clips yet this month. Tell your mods to type !clip during your live!",
  "mods.clips": "{n} clip(s)",
  "mods.views": "{n} views",
  "ce.no_live": "No live auto-clip running. Start it first from Integrations (your live link).",
  "ce.reconnecting": "Reconnecting to the live: try again in a few seconds.",
  "ce.starting": "The live just started: try again in a few seconds.",
  "ce.busy": "A clip is already in progress: wait a few seconds before the next one.",
  "ce.credits": "Your 3 free clips this week are used up. Buy credits to keep going.",
  "ce.bad_key": "Invalid CLIP button link.",
  "live.chat_hint": "Your moderators and VIPs can type !clip (30 s) or !clip 60 (15 to 60 s) in Twitch/Kick chat (max 1 clip every 30 s).",
  "live.chat_last": "last by {u}",
  "push.title": "\"Clip ready\" notification on this phone / PC",
  "push.desc": "Get a notification as soon as a clip is ready (AI or CLIP button), even with the site closed. Turn it on for each device.",
  "push.ios": "On iPhone: tap Share then \"Add to Home Screen\", open CLIP-EX from the icon, then turn this on.",
  "push.unsupported": "This browser doesn't support notifications.",
  "push.denied": "Notifications blocked: allow them in your browser settings.",
  "push.on": "Notifications turned on for this device",
  "push.failed": "Couldn't turn on notifications here (private window?). Try again in a normal window.",
  "push.off": "Notifications turned off for this device",
  "qa.title": "Quick access to the CLIP button",
  "qa.desc": "Scan the QR code with your phone or bookmark this link: it opens the CLIP button directly, no login. Keep it secret (you can regenerate it in Integrations).",
  "qa.copy": "Copy",
  "qa.copied": "CLIP button link copied",
  "qa.key": "On PC: press the C key during a live (on the CLIP button page or here) to clip.",
  "live.clip_busy": "Clipping…",
  "live.clip_ok": "Last 30 seconds sent: your clip will appear in My clips.",
  "live.reconnecting": "Auto-reconnecting to the live…",
  "live.stats": "{s} segments · {c} clips",
  "live.st_live": "Live", "live.st_stopped": "Stopped", "live.st_finished": "Finished", "live.st_error": "Error",
  "ai.title": "AI editor — tell it what to do",
  "ai.sub": "Write your request in one sentence: the AI places effects, stickers, sounds, text and framing for you. Everything stays editable.",
  "ai.ph": "e.g. make it funny with a bruh when he dies",
  "ai.idea1": "Make this clip completely insane with sounds and stickers",
  "ai.idea2": "Funny meme version with slow-mo on the fail",
  "ai.idea3": "Epic cinematic version for a headshot",
  "ai.applied": "AI edit applied — tweak anything you want",
  "fx.preview": "Real effects preview (6s render)",
  "fx.preview_title": "Final render preview",
  "fx.preview_loading": "Rendering preview...",
  "int.plugins": "Plugins per platform",
  "int.dl_watcher": "Download CLIP-EX Watcher",
  "int.watcher_t": "CLIP-EX Watcher (universal)",
  "int.watcher_d": "Watches your captures folder and sends every new video to the AI. Run: python clipx_watcher.py \"folder\".",
  "int.bookmarklet_t": "\"Clip with CLIP-EX\" button",
  "int.bookmarklet_d": "Drag this button to your bookmarks bar. On a Twitch, Kick, YouTube or TikTok page, click it: the video is imported and the AI finds the moments.",
  "int.bookmarklet_btn": "Clip with CLIP-EX",
  "int.how_overlay": "Overlay (Browser / Link source)",
  "int.how_watcher": "Watched folder (Watcher)",
  "int.how_import": "Link import / bookmark",
  "int.how_script": "Official script",
  "int.folder": "Folder:",
  ...hubEn,
  ...landingEn,
  ...socialEn,
  ...growEn,
};
